import { render, staticRenderFns } from "./submissions-review.page.vue?vue&type=template&id=bb4af1ec&scoped=true&"
import script from "./submissions-review.page.vue?vue&type=script&lang=js&"
export * from "./submissions-review.page.vue?vue&type=script&lang=js&"
import style0 from "./submissions-review.page.vue?vue&type=style&index=0&id=bb4af1ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4af1ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
